import { FaArrowLeft } from 'react-icons/fa';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useState } from 'react';
export default function Header({ onSave, isSaving, funnelId, title, isDarkMode, toggleDarkMode, handlePublish, isPublishing }) {
 
    return (
    <div className="flex items-center justify-between px-8 py-2 bg-gray-800  shadow-sm w-full h-12 fixed top-0 left-0"
    style={{
      zIndex: 10000,
    }}
    >
      <div className="flex items-center space-x-4">
        <a
          className="text-gray-200 px-4 py-2 rounded hover:text-gray-400 hover:cursor-pointer transition flex items-center gap-2"
          type="button"
          style={{
            fontSize: "14px",
          }}
          onClick={() => window.open('/dashboard/funnels',  '_self')}
        >
          <FaArrowLeft className="text-gray-200" /> Dashboard
        </a>
        <h1 className="text font-bold text-gray-200">{title}</h1>
      </div>

    



      <div className="flex items-center space-x-3">
          <button 
          className={`${isDarkMode ? 'bg-gray-800 text-gray-400 hover:bg-gray-700' : '  text-gray-700 hover:bg-gray-50'} rounded-md p-2 shadow-md text-sm mr-2 transition-colors`}
          onClick={toggleDarkMode}
          title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        >
          {isDarkMode ? <FaSun /> : <FaMoon />}
        </button>
      <div className="flex items-center space-x-4">
        <button
          className="text-gray-200 px-4 py-2 rounded hover:text-gray-400 hover:cursor-pointer transition flex items-center gap-2"
          type="button"
          style={{
            fontSize: "14px",
          }}
          onClick={() => {
            if (typeof window !== "undefined") {
              // Open config funnel modal, assuming a prop or context function is available
              if (typeof window.openConfigFunnelDesign === "function") {
                window.openConfigFunnelDesign();
              }
            }
          }}
        >
          Design
        </button>
       
      </div>

      <div className="flex items-center space-x-4">
        <button
            className="text-gray-200 px-4 py-2 rounded hover:text-gray-400 hover:cursor-pointer transition flex items-center gap-2"
          type="button"
          style={{
            fontSize: "14px",
          }}
          onClick={() => {
            if (typeof window !== "undefined") {
              // Open config funnel modal, assuming a prop or context function is available
              if (typeof window.openConfigFunnelModal === "function") {
                window.openConfigFunnelModal();
              }
            }
          }}
        >
          Configurações
        </button>
       
      </div>
      <button

            className="  text-gray-200 px-4 py-2 rounded hover:text-gray-400 transition"
          type="button"
          onClick={() => {handlePublish()}}
          style={{
            fontSize: "14px",
          }}
        >
          {isPublishing ? 'Publicando...' : 'Publicar'}
        </button>
   
    
    <a
          className="text-gray-200 px-4 py-2 rounded hover:text-gray-400 transition"
          href={`/preview/${funnelId}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontSize: "14px",
          }}
        >
          Preview
        </a>
        <button
          onClick={onSave}
          className="relative px-3 py-1 rounded bg-orange-600 hover:bg-orange-700 transition-all duration-300 text-white font-semibold flex items-center gap-2"
          disabled={isSaving}
          style={{
            fontSize: "14px",
          }}
        >
          {isSaving && (
            <svg className="animate-spin h-5 w-5 mr-2 text-white" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12" cy="12" r="10"
                stroke="currentColor" strokeWidth="4" fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
          )}
          {isSaving ? " " : "Salvar"}
        </button>
      </div>

    </div>
  );
}   